import React from 'react';
import PropTypes from 'prop-types';
import { ALIGNMENT_OPTIONS, HEADING_LEVELS, HEADING_STYLES, LINK_TYPES } from '../../lib/constants';
import styles from './BlogCtaBanner.module.scss';
import { Button, Heading } from '../index';
import cx from 'classnames';

const BlogCtaBanner = (props) => {
    const {
        headingText,
        headingLevel,
        headingLevelStyle,
        headingTextAlignment,
        hideFromTableOfContent,
        ctaText,
        altText,
        ctaUrl,
        ctaType,
        backgroundColour,
        targetId,
    } = props;

    return (
        <div className={cx(styles['wrapper'], styles[`wrapper--${backgroundColour}`])}>
            <Heading
                headingLevel={headingLevel}
                overrideStyle={headingLevelStyle}
                hideFromTableOfContent={hideFromTableOfContent}
                alignment={headingTextAlignment}
                color={backgroundColour === 'dark-purple' ? 'white' : 'darkPurple'}
            >
                <span dangerouslySetInnerHTML={{ __html: headingText }} />
            </Heading>
            {!!ctaText && (
                <div className={styles['wrapper__button']}>
                    <Button
                        linkText={ctaText}
                        linkUrl={ctaUrl}
                        linkType={ctaType}
                        altText={altText ? altText : ctaText}
                        buttonStyle={backgroundColour === 'dark-purple' ? 'white' : 'purple'}
                        targetId={targetId}
                    />
                </div>
            )}
        </div>
    );
};

BlogCtaBanner.displayName = 'BlogCtaBanner';

BlogCtaBanner.propTypes = {
    headingText: PropTypes.string.isRequired,
    headingLevel: PropTypes.oneOf(HEADING_LEVELS).isRequired,
    headingLevelStyle: PropTypes.oneOf(HEADING_STYLES).isRequired,
    headingTextAlignment: PropTypes.oneOf(ALIGNMENT_OPTIONS),
    hideFromTableOfContent: PropTypes.bool,
    ctaText: PropTypes.string,
    altText: PropTypes.string,
    ctaUrl: PropTypes.string,
    ctaType: PropTypes.oneOf(LINK_TYPES),
    backgroundColour: PropTypes.oneOf(['dark-purple', 'light-purple']).isRequired,
    targetId: PropTypes.string,
};

export default BlogCtaBanner;
